var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"player-main",class:'player-main--' + _vm.variant},[_c('div',{staticClass:"player-box"},[_c('div',{staticClass:"dms-player-container",attrs:{"id":_vm.containerId}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }